import React from "react";
import { formatDateFull } from "../../utils/helper";
export const AlertNotification = ({ item }) => {
  const arr = item.description.split("|");
  const machine = arr[0];
  const location = arr[1];
  const alert_status = arr[2];

  return (
    <div sx={{ fontSize: 12, marginTop: "5px" }}>
      <div className={"row"} container spacing={1}>
        <div className={"col-sm-12"}>
          <b>
            {item.notif_type === "Alert"
              ? "New Machine Alert Detected!"
              : "Alert Need to be resolved"}
          </b>
        </div>
        <div className={"col-sm-4"}>Recorded on</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{formatDateFull(item.created_at)}</div>

        <div className={"col-sm-4"}>Machine</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{machine}</div>

        <div className={"col-sm-4"}>Location</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{location}</div>

        <div className={"col-sm-4"}>Alert Status</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>
          <div
            className={
              alert_status?.toLowerCase() === "open"
                ? "status-open"
                : alert_status?.toLowerCase() === "closed"
                ? "status-close"
                : alert_status?.toLowerCase() === "invalid"
                ? "status-invalid"
                : "status-progress"
            }
            style={{
              textAlign: "center",
              fontSize: "13px",
              width: "95px",
              color:
                alert_status?.toLowerCase() !== "invalid"
                  ? "#2A2E5D"
                  : "#FFFFFF",
            }}
          >
            {alert_status}
          </div>
        </div>
      </div>
    </div>
  );
};
